/* eslint-disable react/prop-types */
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import BankAccountService from "../../service/bank-account-service";

const bankAccountService = new BankAccountService();

await loadDictionary("bank-account-balance-bank-account-window");
await loadDictionary("global");
await loadDictionary("bank-account-types");

function BalanceBankAccountWindow({isOpenWindow, onCloseWindow, bankAccountId}) {
  const spinner = <div className="text-center"><Spinner animation="grow" /></div>;
  const [bankAccountBalanceSection, setBankAccountBalanceSection] = useState(null);
  const handleClose = () => {
    onCloseWindow();
    setBankAccountBalanceSection(null);
  };

  useEffect(() => {
    if(!isOpenWindow || !bankAccountId) return;

    bankAccountService.balance(bankAccountId).then(bankAccountBalance => {
      let bankAccountBalanceSection = (<></>);
      
      if(bankAccountBalance) {
        bankAccountBalanceSection = (
        <>
          <p className="fs-5">{bankAccountBalance?.name}</p>
          <p><span className="text-dark-emphasis">{i18n.t("bank-account-balance-bank-account-window.bank_name")}: </span> {bankAccountBalance?.bank?.name}</p>
          <p><span className="text-dark-emphasis">{i18n.t("bank-account-balance-bank-account-window.type")}: </span> {i18n.t(`bank-account-types.${bankAccountBalance?.type}`)}</p>
          <p><span className="text-dark-emphasis">{i18n.t("bank-account-balance-bank-account-window.account_number")}: </span> {bankAccountBalance?.account_number}</p>
          <p><span className="text-dark-emphasis">{i18n.t("bank-account-balance-bank-account-window.iban")}: </span> {bankAccountBalance?.iban}</p>
          <p><span className="text-dark-emphasis">{i18n.t("bank-account-balance-bank-account-window.card_number")}: </span> {bankAccountBalance?.card_number}</p>
          <p className="fs-4 text-center">{Number(bankAccountBalance?.balance).toLocaleString()} <span>{i18n.t("global.rial")}</span></p>
        </>);
      } else {
        bankAccountBalanceSection = (
        <>
          <p className="text-warning-emphasis text-center">{i18n.t("bank-account-balance-bank-account-window.alert")}</p>
        </>);
      }

      setBankAccountBalanceSection(bankAccountBalanceSection);
    });
  }, [isOpenWindow, bankAccountId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("bank-account-balance-bank-account-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bankAccountBalanceSection || spinner}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("bank-account-balance-bank-account-window.close_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BalanceBankAccountWindow;